import { getDelQKeyUrl, getWxSDKSignatureUrl, parseQueryParams } from '@/utils/url';
import { nowIsHLQ, wxLogin } from '@/utils/wxTools';
import { WxLoginType, WxInitSDKUseFunNameArr } from '@/typeAll';
import { getInitWxSdkInfo } from '@/api/wx';

export default {
    data() {
        return {
            mixDefShareConf: {
                title: document.title, // 分享标题
                desc: '看来看看吧', // 分享描述
                link: getDelQKeyUrl(location.href), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://vvfly.cn/images/header_logo.png', // 分享图标
            },
            // 是否设置自动分享
            mixShareHandelAuto: false,
            // 当前的页面是否在显示
            mixNowPageShow: true,
        };
    },
    created() {},
    activated() {
        const { mixShareHandelAuto } = this;
        mixShareHandelAuto && this.mixShareHandelAll();
    },
    methods: {
        // 用于微信的强制登录(用于打开页面就登录)
        mixWxForceLogin(redirectUrl, loginType = WxLoginType.userinfo) {
            const { code } = parseQueryParams(location.href);
            // eslint-disable-next-line no-unused-vars
            const { inWx, token } = this.$store.state;
            if (!token && !code) {
                const useUrl = redirectUrl || getDelQKeyUrl(location.href);
                this.mixWxLoginUserInfo(useUrl, loginType);
            } else if (code) {
                // APP.vue 处理带 code 的情况
            }
            /* if (inWx) {
                if (!token && !code) {
                    this.mixWxLoginUserInfo(location.href);
                } else if (code) {
                    // APP.vue 处理带 code 的情况
                }
            } else {
                this.mixH5LoginUserInfo();
            } */
        },
        // 微信登录(获取用户信息)
        mixWxLoginUserInfo(redirectUrl, loginType = WxLoginType.userinfo) {
            wxLogin(redirectUrl || location.href, loginType);
        },
        mixH5LoginUserInfo() {
            // 跳转登录页?
            console.log('mixH5LoginUserInfo 待实现');
        },
        // 初始化微信SDK, 一般不直接使用本方法
        async mixInitWxSdkMain() {
            console.log('mixInitWxSdkMain init');
            const { initWxSdkOk, inWx } = this.$store.state;
            if (!inWx || initWxSdkOk) {
                return true;
            }
            const sendData = {
                url: getWxSDKSignatureUrl(location.href),
                // url: 'https://monitor.api.vvfly.cn/h5/wxTest/',
            };
            const resData = await getInitWxSdkInfo(sendData);
            await new Promise((resolve, reject) => {
                const { nonceStr, signature, timestamp } = resData;
                window.wx.ready(() => {
                    console.log('sdk初始化 成功');
                    this.$store.commit('setAny', { initWxSdkOk: true });
                    resolve();
                });
                window.wx.error((e) => {
                    console.log('sdk初始化 失败', e);
                    this.$toast('微信sdk初始化失败');
                    reject();
                });
                window.wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    // appId: process.env.VUE_APP_WX_APPID, // 必填，公众号的唯一标识
                    appId: nowIsHLQ()
                        ? process.env.VUE_APP_WX_APPID
                        : process.env.VUE_APP_WX_APPID_VVFLY, // 必填，公众号的唯一标识
                    timestamp, // 必填，生成签名的时间戳
                    nonceStr, // 必填，生成签名的随机串
                    signature, // 必填，签名
                    jsApiList: WxInitSDKUseFunNameArr, // 必填，需要使用的JS接口列表
                });
            });
            return true;
        },
        // 初始化微信SDK
        mixInitWxSdk() {
            const key = '__InitWxSdkP';
            const InitWxSdkP = this[key];
            if (InitWxSdkP) {
                return InitWxSdkP;
            }
            this[key] = this.mixInitWxSdkMain();
            return this[key];
        },
        // 分享处理
        mixShareHandel() {
            const { mixShareConf, mixDefShareConf } = this;
            const { inWx } = this.$store.state;
            const usePageInfo = { ...mixDefShareConf, ...mixShareConf };
            if (!inWx) {
                return;
            }
            window.wx.updateAppMessageShareData({
                ...usePageInfo,
                success() {
                    // 设置成功
                },
            });

            window.wx.updateTimelineShareData({
                ...usePageInfo,
                success() {
                    // 设置成功
                },
            });
        },
        // 分享处理, 如果skd 没有初始化, 则初始化后处理
        async mixShareHandelAll() {
            const { initWxSdkOk, inWx } = this.$store.state;
            if (!inWx) {
                return;
            }
            if (initWxSdkOk) {
                this.mixShareHandel();
            } else {
                await this.mixInitWxSdk();
                this.mixShareHandel();
            }
        },

        // 微信支付, 传入签名
        wxPlay(data) {
            const { inWx } = this.$store.state;
            if (!inWx) {
                this.$toast('请在微信APP内打开本页面');
            }
            return new Promise((resolve, reject) => {
                function onBridgeReady() {
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest',
                        {
                            // appId: process.env.VUE_APP_WX_APPID, // 公众号ID，由商户传入
                            appId: nowIsHLQ()
                                ? process.env.VUE_APP_WX_APPID
                                : process.env.VUE_APP_WX_APPID_VVFLY,
                            // timeStamp: '1395712654', // 时间戳，自1970年以来的秒数
                            // nonceStr: 'e61463f8efa94090b1f366cccfbbb444', // 随机串
                            // package: 'prepay_id=wx21201855730335ac86f8c43d1889123400',
                            // signType: 'RSA', // 微信签名方式：
                            // paySign: 'o4LdT9', // 微信签名
                            ...data,
                            timeStamp: `${data.timeStamp}`,
                        },
                        (res) => {
                            if (res.err_msg === 'get_brand_wcpay_request:ok') {
                                // 使用以上方式判断前端返回,微信团队郑重提示：
                                // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                resolve();
                            } else {
                                reject();
                            }
                        },
                    );
                }
                if (typeof WeixinJSBridge === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                } else {
                    onBridgeReady();
                }
            });
        },
    },
};
